export default __webpack_public_path__ + "static/profile-secondary-880f4a97c610afe5efdd28c2ae9de06a.jpg";